<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
                </span>
                ANALISI COSTI
            </div>
        </div>    
        <div class="tab-cont" id="style-3" >
            <table class="table"  >
                <thead class="thead-dark">
                    <tr>
                        <th class="text">PIATTO</th>
                        <th class="text">COSTO PIATTO</th>
                        <th class="text">GUADAGNO PIATTO</th>
                        <th class="text">RICAVO PIATTO</th>
                    </tr>
                    </thead>
                    <tbody >
                        <tr v-for="ana in anaC" :key="ana.nome">
                            <td class="text pointer" >{{ana.nome}}</td>
                            <td class="text" >{{ana.spesa}}</td>
                            <td class="text" >{{ana.costo}}</td>
                            <td class="text" >{{ana.costo - ana.spesa}}</td>
                        </tr>
                    </tbody>
            </table>
        </div>
        
    </div>
</template>

<script>
// @ is an alias to /src
import { store } from '../store/store.js'

export default {
  name: 'TabellaMapP',
  data: function () {
            return {
                prodotti:[],
                quantita:'',
                anaC :[],
                store

            }
   },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    anaCosti() {
        this.axios.post(this.store.path+'createAna',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data)
            if(response.data){
                this.anaC = response.data;
                console.log('Analisi dei costi caricata')
            }else{console.log("Non è stato possibile creare  l'analisi dei costi")}
        })
    },
  },
  
  beforeMount() {
      this.anaCosti();
  },
  
}
</script>

<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f8f9fa;
}

.nav-sale {
    padding: 15px;
    background: white;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.con-sal {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    font-weight: bold;
    color: #333;
}

.tab-cont {
    flex-grow: 1;
    overflow-x: auto;
    padding: 15px;
}

.table {
    width: 100%;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    border-collapse: collapse;
    overflow: hidden;
}

.thead-dark th {
    position: sticky;
    top: 0;
    background-color: #343a40;
    color: white;
    z-index: 10;
    padding: 15px;
    text-align: left;
    white-space: nowrap;
}

td {
    padding: 12px 15px;
    border-bottom: 1px solid #eee;
    text-align: left;
}

@media (max-width: 600px) {
    .con-sal {
        flex-direction: column;
        gap: 10px;
    }
    th, td {
        padding: 10px;
        font-size: 0.9rem;
    }
}
</style>